import React from 'react'

function ArchiveIcon({ width = 18, height = width * 1.3, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 18 24"
      {...props}
    >
      <path
        fill="#56565A"
        fillRule="evenodd"
        d="M15.76 5.232A2.5 2.5 0 0 1 16.493 7a2.5 2.5 0 0 1-.834 1.85V17a2.5 2.5 0 0 1-2.5 2.5H4.826a2.5 2.5 0 0 1-2.5-2.5V8.85A2.5 2.5 0 0 1 3.993 4.5h10a2.5 2.5 0 0 1 1.767.732Zm-1.767.935h-10a.833.833 0 1 0 0 1.666h10a.833.833 0 1 0 0-1.666Zm-.244 11.422a.834.834 0 0 0 .244-.589V9.5h-10V17a.833.833 0 0 0 .833.833h8.333a.834.834 0 0 0 .59-.244ZM7.218 12h3.55c.4 0 .725.325.725.725v.217c0 .4-.325.725-.725.725h-3.55a.725.725 0 0 1-.725-.725v-.217c0-.4.324-.725.725-.725Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default ArchiveIcon
